module.exports = __webpack_public_path__ + "static/media/emojis2_28.a06c60e9.svg";